import {PLATFORM, customElement, containerless, useView, bindable} from 'aurelia-framework';
import {GroupViewHeader} from './view-header';

@containerless()
@useView(PLATFORM.moduleName('./view-header.html'))
@customElement('group-reports-view-header')
export class GroupReportsViewHeader extends GroupViewHeader {
  atReports = true;
  @bindable groupData;
}
